import { useEffect, useState } from "react";
import classes from "./SimilarProducts.module.css";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { db } from "../index";
import SimilarProductList from "./SimilarProductList";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router";
import Button from "react-bootstrap/Button";

function SimilarProducts({ product }) {
	const [items, setItems] = useState([]);

	//stringify items for easy change detection by useEffect
	const stringified_items = JSON.stringify(items)

	const [loading, setLoading] = useState(true);

	// for navigation
	const navigate = useNavigate("");

	useEffect(() => {
		window.scrollTo(0, 0);
		//eslint-disable-next-line
	}, [stringified_items]);


	useEffect(() => {
		const collection_ref = collection(db, "items");

		const query_args = query(
			collection_ref,
			where("category_ref", "==", product.category_ref),
			limit(12)
		);

		const loadProducts = async () => {
			setLoading(true);
			try {
				const data = [];
				const loadedProducts = await getDocs(query_args);
				loadedProducts.forEach((eachItem) =>
					data.push({
						id: eachItem.id,
						...eachItem.data(),
					})
				);
				// exclude the product in the product info page from similar product
				const index = data.findIndex((item) => item.id === product.id);
				data.splice(index, 1);
				setItems(data);
			} catch (error) {
				console.error(error);
			} finally {
				setLoading(false);
			}
		};
		loadProducts();
	}, [product]);

	//function called when product doesn't have similar products, used to re route user to continue shopping
	const continueShopping = () => {
		navigate("/products");
	};

	return (
		<div className={classes.main}>
			<h6
				style={{
					borderBottom: "1px solid #ccc",
					padding: "0.5rem",
				}}
			>
				Similar Products
			</h6>
			{loading && (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						padding: "2rem",
					}}
				>
					<PulseLoader
						color={"#A8C4B8"}
						loading={loading}
						size={10}
						aria-label="Loading Spinner"
						data-testid="loader"
					/>
				</div>
			)}

			{!loading && items.length === 0 && (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						padding: "1rem",
						margin: "1rem",
					}}
				>
					<img src="/images/empty-box.png" alt="emptybox" width={80}/>
					<p style={{fontStyle: "oblique", fontFamily: "cursive"}}>Sorry there are no similar products</p>

					<Button
						variant="success"
						className="rounded-1"
						onClick={continueShopping}
					>
						Continue Shopping
					</Button>
				</div>
			)}

			{!loading && items.length !== 0 && (
				<SimilarProductList cards={items} />
			)}
		</div>
	);
}
export default SimilarProducts;
